import { atom } from 'recoil';

export const inviteParentUtilityStateAtom = atom({
  key: 'inviteParentUtilityStateAtom',
  default: {
    open: false,
  },
});
